import apiClient from "@/api/axios";

/**
 * Eliminar un usuario
 * @param {String} id ID del usuario
 * @returns {Promise<void>}
 */
export const deleteCar = async (id) => {
    try {
        await apiClient.delete(`/admin/cars/${id}`);
    } catch (error) {
        console.error('Error al eliminar el carro:', error);
        throw error;
    }
};

/**
 * Obtener un carro
 * @param {String} id ID del carro
 * @returns {Promise<Object>} Carro
 */
export const getCar = async (id) => {
    try {
        const response = await apiClient.get(`/admin/cars/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener el carro:', error);
        throw error;
    }
};

/**
 * Asignar un chofer a un carro
 * @param {String} id ID del carro
 * @param {String} driverId ID del chofer
 * @returns {Promise<Object>} Carro actualizado
 */
export const assignDriver = async (id, driverId) => {
    try {
        const response = await apiClient.put(`/admin/cars/${id}/assign-driver`, { driverId });
        return response.data;
    } catch (error) {
        console.error('Error al asignar el chofer:', error);
        throw error;
    }
};

/**
 * Crear un nuevo carro
 * @param {Object} car Datos del carro
 * @returns {Promise<Object>} Carro creado
 */
export const createCar = async (car) => {
    try {
        const response = await apiClient.post('/admin/cars', car);
        return response.data;
    } catch (error) {
        console.error('Error al crear el carro:', error);
        throw error;
    }
};

/**
 * Editar un carro
 * @param {String} id ID del carro
 * @param {Object} car Datos del carro a actualizar
 * @returns {Promise<Object>} Carro actualizado
 */
export const updateCar = async (id, car) => {
    try {
        const response = await apiClient.put(`/admin/cars/${id}`, car);
        return response.data;
    } catch (error) {
        console.error('Error al actualizar el carro:', error);
        throw error;
    }
};
